module.exports = __webpack_public_path__ + "static/media/senape.23563931.svg";